import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'core-js/features/map';
import 'core-js/features/set';
import 'url-search-params-polyfill';
